@if (!item()) {
  <div class="card border-0 shadow-sm text-center p-5 text-muted d-flex align-items-center justify-content-center" style="min-height: 480px;">
    <div class="my-auto">
      <div class="mb-3 p-4 rounded-circle bg-light d-inline-flex align-items-center justify-content-center" style="width: 80px; height: 80px;">
        <i class="fas fa-envelope-open-text text-primary fa-2x"></i>
      </div>
      <h5 class="fw-bold text-dark mb-1">Ningún correo seleccionado</h5>
      <p class="small text-muted mb-0">Selecciona un correo en la lista de la izquierda para ver su contenido.</p>
    </div>
  </div>} @else {
  @if (appSettings.isMobile()) {
    <!-- VISTA MÓVIL: Botones libres superiores -->
    <div class="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
      <div class="btn-group btn-group-sm" role="group">
        <button type="button" class="btn"
                [ngClass]="activeTab() === 'markdown' ? 'btn-primary' : 'btn-outline-secondary'"
                (click)="activeTab.set('markdown')">
          <i class="fas fa-align-left me-1"></i> Vista Adaptada
        </button>
        <button type="button" class="btn"
                [ngClass]="activeTab() === 'html' ? 'btn-primary' : 'btn-outline-secondary'"
                (click)="activeTab.set('html')">
          <i class="fas fa-code me-1"></i> Plantilla HTML
        </button>
      </div>
      @if (activeTab() === 'markdown' && detail()?.bodyMd) {
        <span class="badge bg-success-subtle text-success border border-success-subtle small">
          <i class="fas fa-check-circle me-1"></i> Markdown Nativo
        </span>
      }
    </div>

    <!-- Panel 1 (Superior): Lo que se envió -->
    <div class="card border-0 shadow-sm mb-3">
      <div class="card-body p-2 p-sm-3">
        @if (loadingBody()) {
          <div class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <div class="text-muted small mt-2">Cargando contenido...</div>
          </div>
        } @else if (activeTab() === 'markdown') {
          <div class="mail-markdown-card p-3 border rounded">
            <div class="markdown-rendered-content" [innerHTML]="renderedMarkdown()"></div>
          </div>
        } @else {
          <div class="preview-frame-wrapper ">
            <iframe
              class="preview-iframe w-100"
              style="border: none;"
              [srcdoc]="detail()?.bodyHtml || '<p style=\'padding: 20px; color: #777;\'>Sin contenido HTML disponible.</p>'">
            </iframe>
          </div>
        }
      </div>
    </div>

    <!-- Panel 2 (Inferior): A quién le llegó o formulario de reenvío -->
    <div class="card border-0 shadow-sm mb-3">
      <div class="card-body p-3">
        <ng-container *ngTemplateOutlet="recipientInfoBlock"></ng-container>
      </div>
    </div>
  } @else {
    <!-- VISTA ESCRITORIO: Panel único con cabecera y cuerpo -->
    <div class="card border-0 shadow-sm">
      <div class="card-header py-3 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <h5 class="fs-6 mb-0 text-dark fw-bold text-truncate" style="max-width: 480px;">
            <i class="fas fa-envelope-open-text text-primary me-2"></i>
            {{ item()?.subject || '(Sin asunto)' }}
          </h5>
          @if (item()?.status === 'SENT') {
            <span class="badge bg-success">ENVIADO</span>
          } @else if (item()?.status === 'FAILED') {
            <span class="badge bg-danger">FALLIDO</span>
          } @else {
            <span class="badge bg-warning text-dark">OMITIDO</span>
          }
          @if (item()?.category) {
            <span class="badge border border-secondary text-secondary">{{ item()?.category }}</span>
          }
          @if (item()?.hasAttachment) {
            <span class="badge bg-info text-dark" [ngbTooltip]="item()?.attachmentName || 'Archivo adjunto'">
              <i class="fas fa-paperclip me-1"></i>{{ item()?.attachmentName || 'Adjunto' }}
            </span>
          }
        </div>

        <!-- Acciones en escritorio -->
        <div class="d-flex align-items-center gap-2">
          @if (canResend()) {
            @if (!isResendMode()) {
              @if (item()?.status === 'FAILED') {
                <button type="button" class="btn btn-warning btn-sm px-3 fw-semibold text-dark shadow-sm"
                        (click)="executeRetry()" [disabled]="isRetrying()">
                  @if (isRetrying()) {
                    <span class="spinner-border spinner-border-sm me-1"></span> Reintentando...
                  } @else {
                    <i class="fas fa-redo me-1"></i> Reintentar
                  }
                </button>
                <button type="button" class="btn btn-outline-secondary btn-sm"
                        (click)="enterResendMode()" [disabled]="isRetrying()"
                        ngbTooltip="Cambiar destinatario o copia">
                  <i class="fas fa-paper-plane me-1"></i> Reenviar a otro...
                </button>
              } @else {
                <button type="button" class="btn btn-primary btn-sm px-3" (click)="enterResendMode()">
                  <i class="fas fa-paper-plane me-1"></i> Reenviar
                </button>
              }
            } @else {
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelResendMode()" [disabled]="isResending()">
                <i class="fas fa-times me-1"></i> Cancelar
              </button>
              <button type="button" class="btn btn-success btn-sm px-3" (click)="executeResend()" [disabled]="isResending()">
                @if (isResending()) {
                  <span class="spinner-border spinner-border-sm me-1"></span> Enviando...
                } @else {
                  <i class="fas fa-paper-plane me-1"></i> Enviar
                }
              </button>
            }
          }
        </div>
      </div>

      <div class="card-body p-3">
        <ng-container *ngTemplateOutlet="recipientInfoBlock"></ng-container>
        <ng-container *ngTemplateOutlet="mailViewerBlock"></ng-container>
      </div>
    </div>
  }

  <!-- Barra de acciones inferior en dispositivos móviles -->
  <app-mobile-footer [visible]="appSettings.isMobile() && !!item()">
    @if (canResend()) {
      @if (!isResendMode()) {
        @if (item()?.status === 'FAILED') {
          <button type="button" class="btn btn-warning flex-fill fw-semibold text-dark shadow-sm"
                  (click)="executeRetry()" [disabled]="isRetrying()">
            @if (isRetrying()) {
              <span class="spinner-border spinner-border-sm me-1"></span> Reintentando...
            } @else {
              <i class="fas fa-redo me-1"></i> Reintentar
            }
          </button>
          <button type="button" class="btn btn-outline-secondary flex-fill"
                  (click)="enterResendMode()" [disabled]="isRetrying()">
            <i class="fas fa-paper-plane me-1"></i> Reenviar a otro...
          </button>
        } @else {
          <button type="button" class="btn btn-primary w-100 fw-semibold shadow-sm" (click)="enterResendMode()">
            <i class="fas fa-paper-plane me-1"></i> Reenviar
          </button>
        }
      } @else {
        <button type="button" class="btn btn-outline-secondary flex-fill" (click)="cancelResendMode()" [disabled]="isResending()">
          <i class="fas fa-times me-1"></i> Cancelar
        </button>
        <button type="button" class="btn btn-success flex-fill fw-semibold shadow-sm" (click)="executeResend()" [disabled]="isResending()">
          @if (isResending()) {
            <span class="spinner-border spinner-border-sm me-1"></span> Enviando...
          } @else {
            <i class="fas fa-paper-plane me-1"></i> Enviar
          }
        </button>
      }
    }
  </app-mobile-footer>
}

<!-- Template Reutilizable: Información del Destinatario o Formulario de Reenvío -->
<ng-template #recipientInfoBlock>
  @if (!isResendMode()) {
    <div [ngClass]="appSettings.isMobile() ? '' : 'border p-3 rounded mb-3 bg-light-subtle'">
      <!-- Chips adicionales en móvil si existen -->
      @if (appSettings.isMobile() && (item()?.category || item()?.hasAttachment)) {
        <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
          @if (item()?.category) {
            <span class="badge border border-secondary text-secondary">{{ item()?.category }}</span>
          }
          @if (item()?.hasAttachment) {
            <span class="badge bg-info text-dark">
              <i class="fas fa-paperclip me-1"></i>{{ item()?.attachmentName || 'Adjunto' }}
            </span>
          }
        </div>
      }
      <div class="row g-2 small">
        <div class="col-12 col-md-6">
          <div><strong>Para:</strong> <span class="fw-semibold text-break">{{ item()?.toMail || 'N/A' }}</span></div>
          <div class="mt-1"><strong>De:</strong> <span class="text-break">{{ item()?.fromMail || 'fpv-noreply@adventistas.org' }}</span></div>
          @if (item()?.ccMail) {
            <div class="mt-1"><strong>CC:</strong> <span class="text-break">{{ item()?.ccMail }}</span></div>
          }
        </div>
        <div class="col-12 col-md-6 text-md-end">
          <div><strong>Fecha:</strong> {{ (item()?.sentAt || item()?.createdAt) | date:'dd/MM/yyyy HH:mm:ss' }}</div>
          @if (item()?.entityCode) {
            <div><strong>Entidad:</strong> {{ item()?.entityCode }}</div>
          }
          @if (item()?.requestUuid) {
            <div class="mt-2">
              <a [routerLink]="['/solicitudes']" [queryParams]="{ uuid: item()?.requestUuid }"
                 target="_blank" class="btn btn-outline-primary btn-xs py-1">
                <i class="fas fa-external-link-alt me-1"></i> Ver Solicitud
              </a>
            </div>
          }
        </div>
      </div>
      @if (item()?.errorMessage) {
        <div class="alert mt-2 mb-0 py-2 small"
             [ngClass]="item()?.status === 'FAILED' ? 'alert-danger' : 'alert-warning'">
          <i class="fas fa-exclamation-triangle me-1"></i>
          <strong>Detalle:</strong> {{ item()?.errorMessage }}
        </div>
      }
    </div>
  } @else {
    <!-- Formulario de reenvío: inputs accesibles para el teclado -->
    <div [ngClass]="appSettings.isMobile() ? '' : 'border p-3 rounded mb-3 bg-light-subtle shadow-sm'">
      <div class="row g-2">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between mb-1">
            <label class="form-label small mb-0 fw-semibold text-dark">Para <span class="text-danger">*</span></label>
            <button type="button" class="btn btn-link btn-xs p-0 text-decoration-none" (click)="fillOriginalRecipient()" [ngbTooltip]="'Usar original: ' + item()?.toMail">
              <i class="fas fa-history me-1"></i> Usar original
            </button>
          </div>
          <input type="email" class="form-control form-control-sm"
                 placeholder="nuevo.destinatario@correo.com"
                 [ngModel]="resendTo()" (ngModelChange)="resendTo.set($event)">
        </div>
        <div class="col-12">
          <label class="form-label small mb-1 fw-semibold text-dark">Copia (CC)</label>
          <input type="text" class="form-control form-control-sm"
                 placeholder="copia@correo.com (opcional)"
                 [ngModel]="resendCc()" (ngModelChange)="resendCc.set($event)">
        </div>
      </div>
    </div>
  }
</ng-template>

<!-- Template Reutilizable: Selector de Formato y Visor de Correo -->
<ng-template #mailViewerBlock>
  @if (loadingBody()) {
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <div class="text-muted small mt-2">Cargando contenido...</div>
    </div>
  } @else {
    <div class="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
      <div class="btn-group btn-group-sm" role="group">
        <button type="button" class="btn"
                [ngClass]="activeTab() === 'markdown' ? 'btn-primary' : 'btn-outline-secondary'"
                (click)="activeTab.set('markdown')">
          <i class="fas fa-align-left me-1"></i> Vista Adaptada
        </button>
        <button type="button" class="btn"
                [ngClass]="activeTab() === 'html' ? 'btn-primary' : 'btn-outline-secondary'"
                (click)="activeTab.set('html')">
          <i class="fas fa-code me-1"></i> Plantilla HTML
        </button>
      </div>
      @if (activeTab() === 'markdown' && detail()?.bodyMd) {
        <span class="badge bg-success-subtle text-success border border-success-subtle small">
          <i class="fas fa-check-circle me-1"></i> Markdown Nativo
        </span>
      }
    </div>

    @if (activeTab() === 'markdown') {
      <div class="mail-markdown-card p-3 p-md-4 border rounded" style="min-height: 480px;">
        <div class="markdown-rendered-content" [innerHTML]="renderedMarkdown()"></div>
      </div>
    } @else {
      <div class="preview-frame-wrapper border rounded">
        <iframe
          class="preview-iframe w-100"
          style="border: none;"
          [srcdoc]="detail()?.bodyHtml || '<p style=\'padding: 20px; color: #777;\'>Sin contenido HTML disponible.</p>'">
        </iframe>
      </div>
    }
  }
</ng-template>
